export const STAFF = [
    {
        id: 0,
        name: "Joanna",
        title: "Translation on web?",
        description: "Hi, I am a 10 year expert on translating various contents communicated on web services.",
        image: '/images/staff/staff_joanna.jpg',
        email: 'joanna@transia.io'
    },
    {
        id: 1,
        name: "Will",
        title: "SEO Translation?",
        description: "Do you want a translation service focused on marketing and social network? I am here for you.",
        image: "/images/staff/staff_will.jpg",
        email: 'will@transia.io'
    },

    {
        id: 2,
        name: "Andrew",
        title: "Media Subtitles?",
        description: "Need a quick translating or cationing service? Then please talk to me.",
        image: '/images/staff/staff_andrew.jpg',
        email: 'andrew@transia.io'
    },
    {
        id: 3,
        name: "Tatianna",
        title: "Video Translation?",
        description: "With +10 experience in film and movie industry, I will assist you through your video project.",
        image: '/images/staff/staff_tatianna.jpg',
        email: 'tatianna@transia.io'
    },
    {
        id: 4,
        name: "Jeff",
        title: "Need a team?",
        description: "Are you planning a big project? Do you need a team? Then you should talk to me. ",
        image: '/images/staff/staff_jeff.jpg',
        email: 'jeff@transia.io'
    },
    {
        id: 5,
        name: "Sonya",
        title: "General Inquiry?",
        description: "As a manager, I am here to answer your questions. If you need full assistance, you should talk to me.",
        image: '/images/staff/staff_sonya.jpg',
        email: 'sonya@transia.io'
    }
]